import {Injectable} from '@angular/core';

import {AdminFacadeService} from '../admin-facade.service';

@Injectable({
  providedIn: 'root'
})
export class AttributionPreloadGuard  {

  constructor(private _adminFacade: AdminFacadeService) {
  }

  canActivate(): boolean {
    this._adminFacade.loadAttributionYear();
    this._adminFacade.loadAttributionValidationDate();
    return true;
  }
}
